import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import { useForm } from "react-hook-form";
import { Helmet } from "react-helmet";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import {
  clearRequest,
  customValidation,
  LoacalVariables,
  setLocalValues,
  validations
} from "../../commonFunctions/CommonFunctions";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import logo from "../../images/willsoar.svg";
import { Link, useNavigate } from "react-router-dom";
import { Google } from "@mui/icons-material";
import axios from "axios";
import { useAuth } from "../../StateManagement/authContext";

const LoginForm: React.FC = React.memo(() => {
  const { control, handleSubmit } = useForm();
  const { showMessage } = useSnackbar();
  const navigate = useNavigate();
  const {user,setIsAuthenticated,setUser} = useAuth();

  const [loading, setLoading] = useState(false);
  const [rememberMe,setRememberMe] = useState(false);

  const handleData = async (data: any) => {
    try {
      const request = {
        email: data.email,
        password: data.password,
        rememberMe: data.rememberMe
      };
      const newRequest = clearRequest(request);
      setLoading(true);

      const response: any = await axios.post(
        "https://simplestimateserver.onrender.com/api/auth/login",
        newRequest,
        { withCredentials: true }
      );
      console.log("response is", response);
      if (response.data?.success) {
        const user = response.data.user;
        setUser(user);
        setIsAuthenticated(true);

        setLocalValues(LoacalVariables.UserId, user._id);
        setLocalValues(LoacalVariables.UserType, user.userType);
        setLocalValues(LoacalVariables.Name, `${user.fname} ${user.lname}`);

        if(user.userType === "employee"){
          setLocalValues(LoacalVariables.EmoloyeeId, user?.employeeId);
        }
        // else if(user.userType === "project_manager"){
        //   setLocalValues(LoacalVariables.UserId, user._id);
        // }

        showMessage(response.data.message, "success");
        navigate('/');
      }
    } catch (error: any) {
      console.error("Failed to login", error);
        if (error.message === 'GlobalHandledError') return;
         showMessage(
        error?.response?.data.message || "Login Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Login | Willsoar Technologies</title>
        <meta
          name="description"
          content="Log in to access your estimates, invoices, clients, and more with our powerful estimation tool."
        />
      </Helmet>

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ minHeight: "80vh", backgroundColor: "#edf1f5" }}
      >
        <Grid item xs={12} textAlign="center">
          <Box
            sx={{
              display: "inline-block",
              px: 4,
              py: 1,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10
            }}
          >
            <img
              src={logo}
              alt="Estimate Logo"
              style={{
                height: 50, // Adjust size as needed
                objectFit: "contain"
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={11} sm={8} md={4}>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "10px",
              padding: 4,
              boxShadow: "0px 4px 15px rgba(0,0,0,0.1)"
            }}
          >
            <Typography variant="h5" fontWeight="bold" textAlign="left" mb={2}>
              Login
            </Typography>

            <form onSubmit={handleSubmit(handleData)}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <WSTextField
                    label="E-Mail Address"
                    rules={customValidation(true, validations.email)}
                    id="email"
                    name="email"
                    control={control}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    label="Password"
                    rules={{ required: true }}
                    id="password"
                    name="password"
                    control={control}
                    type={TextType.Password}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                    }
                    label="Remember Me"
                  />

                 {user?.userType === "admin" &&  <Link
                    to="/forgot/password"
                    style={{ color: "#fe6a2c", textDecoration: "none" }}
                  >
                    Forgot Your Password?
                  </Link>}
                </Grid>

                <Grid item xs={12}>
                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    sx={{
                      backgroundColor: "#fe6a2c",
                      padding: "10px",
                      fontWeight: "bold",
                      "&:hover": {
                        backgroundColor: "#e55d1e"
                      }
                    }}
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </Button>
                </Grid>

                {/* <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="outlined"
                    type="button"
                    startIcon={<Google />}
                    sx={{
                      mt: 1,
                      textTransform: "none",
                      fontWeight: 500
                    }}
                    onClick={() => {
                      window.location.href =
                        "http://localhost:5000/api/auth/login/google";
                    }}
                  >
                    Login with Google
                  </Button>
                </Grid> */}
              </Grid>
            </form>

            {/* <Typography variant="body2" sx={{ mt: 3, textAlign: "center" }}>
              Don't have an account?{" "}
              <Link
                to="/registration"
                style={{ color: "#fe6a2c", textDecoration: "none" }}
              >
                Sign Up
              </Link>
            </Typography> */}
          </Box>
        </Grid>
      </Grid>
    </>
  );
});


export default LoginForm;